<div class="page-innder-body portlet light" [ngClass]="{'p-3':!isAuthenticated}">

    <div class="portlet-body mt-5">
        <div class="border-bottom">
            <p class="text-muted">{{ 'deleteInstagramMetaData.proceedInstructions' | transloco }}</p>
        </div>
            <div class="d-flex mt-4">
                <div class="interaction-section d-flex flex-column justify-content-center align-items-center">
                    <img src="assets/images/thumb_AFP-logo-v02-noTagline-800.png" class="img-fluid mb-4"
                        style="max-width: 200px;" [alt]="'deleteInstagramMetaData.logo' | transloco">
                    <h3 class="text-white">{{ 'deleteInstagramMetaData.welcomeToOurService' | transloco }}</h3>
                    <p class="text-white">{{ 'deleteInstagramMetaData.followInstructions' | transloco }}</p>
                </div>
                <div class="card-container d-flex justify-content-center align-items-center">
                    <div class="card border-0 shadow-lg w-100" style="max-width: 800px;">
                        <div class="d-flex justify-content-between">
                            <div>
                                <h3 class="mb-2">{{ 'deleteInstagramMetaData.deleteMetadata' | transloco }} </h3>
                            </div>
                            <!-- <ng-container *ngIf="platform === 'instagram'; else facebookLogo"> -->
                                <div>
                                    <img src="assets/images/instagram.png" class="img-fluid" style="max-width: 40px;"
                                        [alt]="'deleteInstagramMetaData.instagramLogo' | transloco">
                                </div>
                            <!-- </ng-container> -->
                        </div>

                        <div class="row">
                            <div class="col-md-4 d-flex flex-column align-items-center mt-2">
                                <img [src]="logoImgUrl ? logoImgUrl : 'assets/images/No-Image.png'"
                                    class=" mb-3 rounded-cube" style="height: 150px; object-fit: cover;">
                                <h5 class="mb-1">{{ firstName }}</h5>
                            </div>
                            <div class="col-md-8 d-flex flex-column justify-content-between">
                                <div>
                                    <div class="mb-3">
                                        <label class="form-label fw-bold">{{ 'deleteInstagramMetaData.enterUsername' | transloco }}</label>
                                        <input type="text" class="form-control" [(ngModel)]="username">
                                    </div>
                                    <div class="mb-3">
                                        <label class="form-label fw-bold">{{ 'deleteInstagramMetaData.enterPassword' | transloco }}</label>
                                        <input type="password" class="form-control" [placeholder]="'deleteInstagramMetaData.enterPasswordPlaceholder' | transloco"
                                            [(ngModel)]="password">
                                    </div>
                                </div>
                                <!-- <ng-container *ngIf="platform === 'instagram'; else facebookButton"> -->
                                    <button class="btn btn-danger w-100 mb-3" [disabled]="!isFormValid()"
                                        (click)="deleteInstagramMetaData()">
                                        {{ 'deleteInstagramMetaData.delete' | transloco }}
                                    </button>
                                <!-- </ng-container> -->
                            </div>
                        </div>
                        <div class="mt-4">
                            <p class="text-muted">
                                {{ 'deleteInstagramMetaData.warningParagraph1' | transloco }}
                            </p>
                            <p class="text-muted">
                                {{ 'deleteInstagramMetaData.warningParagraph2' | transloco }}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
    </div>
</div>

<p-dialog [header]="'deleteInstagramMetaData.confirm' | transloco" [(visible)]="isInstagramAccountDeleteConfirmationDailogVisible" [style]="{'width': '350px'}"
    [modal]="true" (onHide)="onCloseInstagramMetadataConfirmationDailog()">
    <div class="d-flex">
        <i class="pi pi-exclamation-triangle pt-1 me-2 text-danger"></i>
        <div>{{ 'deleteInstagramMetaData.confirmDeleteMessage' | transloco }}</div>
    </div>
    <div class="d-flex justify-content-end">
        <button type="button" pButton icon="pi pi-times" [label]="'deleteInstagramMetaData.no' | transloco" class="p-button-secondary p-button-outlined"
        (click)="onCloseInstagramMetadataConfirmationDailog()"></button>
        <button type="button" pButton icon="pi pi-check" [label]="'deleteInstagramMetaData.yes' | transloco" class="p-button-danger ms-2"
        (click)="deleteInstagramAccounts()"></button>
    </div>
</p-dialog>
